module.exports = __webpack_public_path__ + "3fcbbeca32bac42913c5c2e5f812083a.svg";